import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {
    Resolve,
    RouterStateSnapshot,
    ActivatedRouteSnapshot
} from '@angular/router';
import { TemplateService } from '../services/template/template.service';

@Injectable()
export class TemplateResolver implements Resolve<Observable<any>> {

    constructor(private templateService: TemplateService) {}

    resolve(route: ActivatedRouteSnapshot,
            state: RouterStateSnapshot): Observable<any[]> {
        return this.templateService.getById(route.params.templateId) as any;
    }
}
